import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { SOCIAL } from '../mock';
import { CONTACT, SERVICES } from '../mock';
import logoFull from '../assets/logo-full.png';

export default function Footer() {
  return (
    <footer className="mt-24" style={{ background: 'linear-gradient(180deg, var(--cream) 0%, #EDEBDD 100%)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-8 pt-16 pb-8">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="mb-4 flex items-center gap-3">
              <img src={logoFull} alt="Chesapeake Counseling Center" className="h-20 md:h-24 w-auto object-contain" />
              <div className="leading-tight">
                <div className="font-serif text-xl md:text-2xl text-[color:var(--deep-sage)]">Chesapeake Counseling Center</div>
              </div>
            </div>
            <div className="font-script text-2xl text-[color:var(--dusty-rose)] mb-4">Let Your Light Shine</div>
            <p className="text-sm text-[color:var(--taupe-gray)] leading-relaxed">Compassionate care for individuals, couples, and families in every season of life.</p>
            <div className="flex gap-3 mt-5">
              {SOCIAL.map((s) => (
                <a key={s.label} href={s.href} target="_blank" rel="noopener noreferrer" aria-label={s.label} className="w-9 h-9 rounded-full bg-white flex items-center justify-center text-[color:var(--sage-dark)] hover:bg-[color:var(--sage-green)] hover:text-white transition">
                  <s.Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm tracking-[0.28em] uppercase text-[color:var(--sage-dark)] font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2.5 text-sm">
              {[['Home','/'],['About','/about'],['Our Team','/team'],['Why CCC','/why-ccc'],['Blog','/blog'],['Contact','/contact']].map(([l,to]) => (
                <li key={to}><Link to={to} className="text-[color:var(--deep-sage)] hover:text-[color:var(--dusty-rose)] transition">{l}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm tracking-[0.28em] uppercase text-[color:var(--sage-dark)] font-semibold mb-4">Services</h4>
            <ul className="space-y-2.5 text-sm">
              {SERVICES.slice(0,7).map((s) => (
                <li key={s.slug}><Link to={`/services/${s.slug}`} className="text-[color:var(--deep-sage)] hover:text-[color:var(--dusty-rose)] transition">{s.title}</Link></li>
              ))}
              <li><Link to="/services" className="link-underline text-[color:var(--dusty-rose)]">View all counseling services</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm tracking-[0.28em] uppercase text-[color:var(--sage-dark)] font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm text-[color:var(--deep-sage)]">
              <li className="flex gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[color:var(--dusty-rose)]" /><span>{CONTACT.address}<br />{CONTACT.city}</span></li>
              <li className="flex gap-2 items-center"><Phone className="w-4 h-4 text-[color:var(--dusty-rose)]" /><a href={CONTACT.phoneHref} className="hover:text-[color:var(--dusty-rose)]">{CONTACT.phone}</a></li>
              <li className="flex gap-2 items-center"><Mail className="w-4 h-4 text-[color:var(--dusty-rose)]" /><a href={`mailto:${CONTACT.email}`} className="hover:text-[color:var(--dusty-rose)] break-all">{CONTACT.email}</a></li>
              <li className="flex gap-2">
                <Clock className="w-4 h-4 mt-0.5 text-[color:var(--dusty-rose)]" />
                <div className="text-[13px] leading-relaxed">
                  {CONTACT.hours.map(h => (
                    <div key={h.day}><span className="text-[color:var(--taupe-gray)]">{h.day}:</span> {h.time}</div>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t flex flex-col md:flex-row justify-between gap-4 text-xs text-[color:var(--taupe-gray)]" style={{ borderColor: 'var(--soft-border)' }}>
          <div>© {new Date().getFullYear()} Chesapeake Counseling Center. All rights reserved.</div>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-[color:var(--dusty-rose)]">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-[color:var(--dusty-rose)]">Terms of Use</Link>
            <Link to="/existing-clients" className="hover:text-[color:var(--dusty-rose)]">Existing Clients</Link>
            <Link to="/admin/login" className="hover:text-[color:var(--dusty-rose)] opacity-70">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
